import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Invitation from "../Homepage/Invitation";
import {
  InfoIcon,
  EmailIcon,
  PasswordIcon,
  OrderIcon,
  TagsIcon,
  SocialIcon,
} from "../../assets/accountIcons";
import Personal from "./Personal";
import GamerTags from "./GamerTags";
import { SocialConnect } from "./SocialConnect";
import EmailAddress from "./EmailAddress";
import { OrderHistory } from "./OrderHistory";
import PasswordChange from "./PasswordChange";
import { ExternalContainer } from "../../components/Account/reusables";
import { Tabs } from "../../components/Form/types";

const Account = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.pathname === "/order-history"
      ? "Order History"
      : "Personal Information",
  );

  useEffect(() => {
    if (location.pathname === "/order-history") {
      setActiveTab("Order History");
    }
  }, [location.pathname]);
  return (
    <div className="relative h-full min-h-screen w-full min-w-screen bg-white dark:bg-black">
      <span className="hidden bp:flex p-14 pb-2 lt-2xl-semibold-toggleBG-dark dark:text-white">
        Account Details
      </span>
      <div className="px-4 bp:px-14 bp:pt-6 flex flex-col bp:row-8 overflow-y-auto">
        <div className="col-12 bp:w-72">
          <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
          <div className="hidden bp:flex">
            <Invitation />
          </div>
        </div>
        {activeTab === "Personal Information" && <Personal />}
        {activeTab === "Email" && <EmailAddress />}
        {activeTab === "Password" && <PasswordChange />}
        {activeTab === "Order History" && <OrderHistory />}
        {activeTab === "Social Connect" && <SocialConnect />}
      </div>
    </div>
  );
};

export default Account;

const Sidebar = ({ activeTab, setActiveTab }: Tabs) => {
  const tabs = [
    { name: "Personal Information", icon: InfoIcon },
    { name: "Email", icon: EmailIcon },
    { name: "Password", icon: PasswordIcon },
    { name: "Order History", icon: OrderIcon },
    { name: "Social Connect", icon: SocialIcon },
  ];
  const handleTabClick = (e: React.MouseEvent, tabName: string) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveTab(tabName);
  };
  return (
    <ExternalContainer>
      {/* desktop screen */}
      <div className="hidden rounded-xl border py-4 px-3 bp:col-3">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={(e) => handleTabClick(e, tab.name)}
            className={`h-11 rounded-md p-3 row-2 items-center ${
              activeTab === tab.name ? "bg-pry-500" : "hover:bg-gray-200"
            } transition-all duration-300`}
          >
            <tab.icon active={activeTab === tab.name} />
            <span
              className={`font-satoshi text-sm ${
                activeTab === tab.name
                  ? "font-bold text-white"
                  : "font-medium text-tabs"
              }`}
            >
              {tab.name}
            </span>
          </button>
        ))}
      </div>
      {/* mobile screen*/}
      <div className="sticky top-10 rounded-xl border px-3 py-2 row-3 justify-between bp:hidden">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`size-20 rounded-md p-2 col-1 items-center justify-center ${
              activeTab === tab.name ? "bg-pry-500" : "hover:bg-gray-200"
            } transition-all duration-300`}
          >
            <tab.icon active={activeTab === tab.name} />

            {activeTab === tab.name && (
              <span
                className={`font-satoshi text-xs ${
                  activeTab === tab.name
                    ? "font-bold text-white"
                    : "font-medium text-tabs"
                }`}
              >
                {tab.name}
              </span>
            )}
          </button>
        ))}
      </div>
    </ExternalContainer>
  );
};
